<template>
  <div class="game-container">
    <audio ref="correctSound" src="/sounds/nyse.m4a"></audio>
    <h1>Stock Symbol Identification Game</h1>
    <p>Guess the company stock symbol based on the logo and hint provided.</p>
    <button @click="startGame" v-if="!gameStarted">Start Game</button>
    <div v-if="gameStarted">
      <div class="card">
        <img :src="'/logos/' + currentSymbol + '.png'" alt="Logo" class="logo" />
        <p v-if="currentHint">Hint: {{ currentHint }}</p>
        <input v-model="userGuess" placeholder="Enter stock symbol" />
        <button class="hover-button" @click="checkGuess">Check</button>
        <span>&nbsp;</span>
        <button class="hover-button" @click="showHint">Hint</button>
      </div>
      <p>Score: {{ score }}</p>
    </div>
    <div v-if="showStockInfoModal" class="modal">
      <div class="modal-content">
        <span class="close-button rounded-button" @click="closeModal">X</span>
        <button class="more-info-button rounded-button" @click="navigateToStockPage">More Info</button>
        <h4>{{ modalTitle }}</h4>
        <p>Company: {{ Name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import stockData from './stocks.json';

export default {
  data() {
    return {
      stockList: stockData,
      currentSymbol: '',
      currentHint: '',
      userGuess: '',
      score: 0,
      attempts: 0,
      showStockInfoModal: false,
      Name: '',
      sector: '',
      modalTitle: '',
      gameStarted: false
    };
  },
  methods: {
    startGame() {
      this.gameStarted = true;
      this.randomizeStock();
    },
    randomizeStock() {
      const randomIndex = Math.floor(Math.random() * this.stockList.length);
      const selectedStock = this.stockList[randomIndex];
      this.currentSymbol = selectedStock.symbol;
      this.Name = selectedStock.Name;
      this.currentHint = selectedStock.industry;
      this.sector = selectedStock.sector;
      this.userGuess = '';
    },
    closeModal() {
      this.showStockInfoModal = false;
      this.randomizeStock();
      this.userGuess = '';
      this.attempts = 0;
    },
    navigateToStockPage() {
      // Add your logic here to navigate to the stock page.
      console.log('Navigate to the stock page for: ', this.currentSymbol);
    },
    showHint() {
      if (this.attempts >= 4) {
        this.currentHint = 'No more hints!';
        return;
      }
      this.attempts++;
      if (this.attempts === 1) {
        this.currentHint = `The company operates in the ${this.sector} sector.`;
      } else if (this.attempts === 2) {
        this.currentHint = `The company name is ${this.Name}`;
      } else if (this.attempts === 3) {
        this.currentHint = 'Last Hint: The sky is the limit!';
      } else {
        this.currentHint = 'No more hints!';
      }
    },
    checkGuess() {
      this.attempts++;
      if (this.userGuess.toUpperCase() === this.currentSymbol) {
        this.score += 50 - (this.attempts * 10);
        this.modalTitle = 'Correct! 🎉 🙌 😺 ';
        this.$refs.correctSound.play();
      } else {
        this.score -= 10;
        this.modalTitle = 'Wrong guess 😕';
      }
      this.showStockInfoModal = true;
    }
  }
};
</script>

<style scoped>
.close-button,
.more-info-button {
  position: absolute;
  top: 10px;
  cursor: pointer;
  padding: 10px;
  border-radius: 50%;
  background-color: black;
  color: white;
}

.more-info-button {
  right: 50px;
}

.hover-button {
  background-color: #007BFF;
  border: none;
  color: white;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 8px;
}

.hover-button:hover {
  background-color: #0056b3;
}

.game-container {
  text-align: center;
}

.card {
  border: 1px solid black;
  padding: 20px;
  margin: 10px auto;
  max-width: 400px;
  text-align: center;
}

.logo {
  width: 100px;
  height: 100px;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 50%;
}
.close-button {
  right: 10px;
}

.more-info-button {
  right: 50px;
}
</style>
